<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3">
          <div class="list-group">
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 2}" :to="{ name: 'paket' }" v-on:click.native="data.tabActive = 2">
              Paket
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 3}" :to="{ name: 'area' }" v-on:click.native="data.tabActive = 3">
              Area
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 0}" :to="{ name: 'profil' }" v-on:click.native="data.tabActive = 0">
              Profil
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 1}" :to="{ name: 'password' }" v-on:click.native="data.tabActive = 1">
              Password
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'infoprint'}" :to="{ name: 'infoprint' }" v-on:click.native="data.tabActive = 'infoprint'">
              Info Print
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'infowa'}" :to="{ name: 'infowa' }" v-on:click.native="data.tabActive = 'infowa'">
              Teks Info Wa 
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'supportby'}" :to="{ name: 'supportby' }" v-on:click.native="data.tabActive = 'supportby'">
              Teks Support By
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'ppn'}" :to="{ name: 'ppn' }" v-on:click.native="data.tabActive = 'ppn'">
              PPN
            </router-link>
            <router-link class="list-group-item list-group-item-action" v-bind:class="{'active' : data.tabActive === 'slider'}" :to="{ name: 'slider' }" v-on:click.native="data.tabActive = 'slider'">
              Slider Gambar <span class="badge badge-success">Custom Only</span>
            </router-link>
          </div>
        </div>
        <div class="col-md-9">
          <transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'

import { reactive } from '@vue/composition-api'

export default {
  name: 'Beranda',
  setup() {
    const data = reactive({
      params: {},
      tabActive: 2
    })
    return {
      data
        //myGlobal,
    }
  },
  mounted () {
    document.title = "Update Profil";
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.list-group-item {
  color: #333 !important;
}
.active {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/main.vue